import React from 'react';
import { View } from 'react-native';

import { OrderItemCard } from '@components/OrderItemCard';
import { OrderMessageCategory } from '@lib/types';
import { Typography } from '@components/Typography';
import { makeStyles } from '@providers/Theme';
import { useTranslation } from '@providers/I18n';

type OrderDetailsProps = {
  categories: OrderMessageCategory[];
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.base[100],
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));

export const OrderDetails: React.FC<OrderDetailsProps> = ({ categories }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  const items = (categories ?? []).map((cat, i) => (
    <OrderItemCard category={cat} key={i} />
  ));

  return (
    <View style={styles.root}>
      <Typography
        testID="title"
        weight="extraBold"
        size="2xl"
        variant="primary"
        style={styles.title}>
        {t('orderDetails.title')}
      </Typography>
      {items}
    </View>
  );
};
